import { createInertiaApp, router } from '@inertiajs/react'
import { createElement, StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BookingProvider } from '@/contexts/BookingContext'
import { BookingPopup } from '@/components/BookingPopup'
import { NewsletterProvider } from '@/contexts/NewsletterContext'
import { NewsletterPopup } from '@/components/NewsletterPopup'

interface SharedProps {
  booking_url?: string
}

router.on('navigate', () => {
  window.scrollTo(0, 0)
})

void createInertiaApp({
  pages: "../pages",

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" }
    },
  },

  setup({ el, App, props }) {
    const sharedProps = props.initialPage.props as unknown as SharedProps
    const bookingUrl = sharedProps.booking_url ?? ""

    const tree = (
      <StrictMode>
        <BookingProvider>
          <NewsletterProvider>
            {createElement(App, props)}
            <BookingPopup bookingUrl={bookingUrl} />
            <NewsletterPopup />
          </NewsletterProvider>
        </BookingProvider>
      </StrictMode>
    )

    if (!el) {
      throw new Error("Inertia setup: missing root element")
    }
    if (el.hasChildNodes()) {
      hydrateRoot(el, tree)
    } else {
      createRoot(el).render(tree)
    }
  },
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  // Feel free to remove this `catch` if you don't need it.
  if (document.getElementById("app")) {
    throw error
  } else {
    console.error(
      "Missing root element.\n\n" +
      "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
      'Consider moving <%= vite_typescript_tag "inertia.tsx" %> to the Inertia-specific layout instead.',
    )
  }
})
